import { render, staticRenderFns } from "./SpreadsheetElement.vue?vue&type=template&id=4fc16d30&"
import script from "./SpreadsheetElement.vue?vue&type=script&lang=js&"
export * from "./SpreadsheetElement.vue?vue&type=script&lang=js&"
import style0 from "./SpreadsheetElement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VTextField})
